<script lang="ts">
  export let imageUrl: string = "";
  export let fallbackImageUrl: string = "";
  export let altText: string = "Profile Image";
  export let shape: "circle" | "square" = "square";
  export let outline: boolean = false;
  export let imageClass: string = "";
  export let wrapperClass: string = "";
  import { cn } from "$lib/utils.js";

  const fallbackIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-full h-full">
      <path fill-rule="evenodd" d="M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z" clip-rule="evenodd" />
    </svg>
  `;

  let imageLoaded = false;

  function handleImageError(event: Event) {
    imageLoaded = false;
  }

  function handleImageLoad() {
    imageLoaded = true;
  }
</script>

<span
  class={cn(
    "inline-block w-fit",
    outline && "border border-blog-gray-1000 p-1 dark:border-blog-gray-800",
    shape === "circle" ? "rounded-full" : "rounded",
    wrapperClass,
  )}
>
  {#if imageUrl}
    <img
      src={imageUrl}
      alt={altText}
      class={cn("h-full w-full", imageClass, shape === "circle" ? "rounded-full" : "rounded", !imageLoaded && "hidden")}
      on:load={handleImageLoad}
      on:error={handleImageError}
    />
  {/if}

  {#if !imageLoaded}
    {#if fallbackImageUrl}
      <img
        src={fallbackImageUrl}
        alt={altText}
        class={cn("h-full w-full", imageClass, shape === "circle" ? "rounded-full" : "rounded")}
      />
    {:else}
      <span
        class={cn(
          "flex h-full w-full items-center justify-center",
          imageClass,
          shape === "circle" ? "rounded-full" : "rounded",
        )}
      >
        {@html fallbackIcon}
      </span>
    {/if}
  {/if}
</span>

<style>
  .hidden {
    display: none;
  }
</style>
